// Generated by scripts/site-models.mjs from apps/website/content/vehicles.json.
// Do not edit: change the website's content and run the script again.

/**
 * Q-157: the website's own models, as the model map knows them. `photo` is
 * the photo's path on the website (under apps/website/public); the staff app
 * serves the same file under /site-models (copied at build).
 */
export interface SiteModel {
  ref: string
  name: string
  kind: 'car' | 'minivan' | 'scooter' | 'ebike' | 'other'
  seats: number | null
  transmission: 'manual' | 'automatic' | null
  fuel: 'petrol' | 'diesel' | 'hybrid' | 'electric' | null
  photo: string
}

export const SITE_MODELS: readonly SiteModel[] = [
  {
    ref: 'fiat-panda',
    name: 'Panda',
    kind: 'car',
    seats: 5,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/fiat-panda.png',
  },
  {
    ref: 'fiat-600-comfort',
    name: 'Fiat 600 Comfort',
    kind: 'car',
    seats: 4,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/fiat-600.png',
  },
  {
    ref: 'toyota-aygo',
    name: 'Aygo',
    kind: 'car',
    seats: 4,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/toyota-aygo.png',
  },
  {
    ref: 'citroen-c1',
    name: 'Citroën C1',
    kind: 'car',
    seats: 5,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/citroen-c1.png',
  },
  {
    ref: 'peugeot-107',
    name: 'Peugeot 107',
    kind: 'car',
    seats: 5,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/peugeot-107.png',
  },
  {
    ref: 'toyota-aygo-new',
    name: 'Aygo New',
    kind: 'car',
    seats: 4,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/toyota-aygo-new.png',
  },
  {
    ref: 'citroen-c1-new',
    name: 'Citroën C1 New',
    kind: 'car',
    seats: 5,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/citroen-c1-new.png',
  },
  {
    ref: 'fiat-panda-2',
    name: 'Panda 2ª Serie',
    kind: 'car',
    seats: 5,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/fiat-panda-2.png',
  },
  {
    ref: 'fiat-panda-3',
    name: 'Panda 3ª Serie',
    kind: 'car',
    seats: 5,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/fiat-panda-3.png',
  },
  {
    ref: 'fiat-500x-new',
    name: 'Fiat 500x New',
    kind: 'car',
    seats: 5,
    transmission: 'manual',
    fuel: 'diesel',
    photo: '/images/fleet/fiat-500x.png',
  },
  {
    ref: 'fiat-500-new',
    name: 'Fiat 500 New',
    kind: 'car',
    seats: 4,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/fiat-500.png',
  },
  {
    ref: 'vw-maggiolino-cabrio',
    name: 'Maggiolino Cabrio',
    kind: 'car',
    seats: 4,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/vw-maggiolino-cabrio.png',
  },
  {
    ref: 'mini-moke',
    name: 'Mini Moke',
    kind: 'car',
    seats: 4,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/mini-moke.png',
  },
  {
    ref: 'smart-forfour',
    name: 'Smart forfour',
    kind: 'car',
    seats: 5,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/smart-forfour.png',
  },
  {
    ref: 'dacia-jogger',
    name: 'Dacia Jogger',
    kind: 'car',
    seats: 7,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/dacia-jogger.png',
  },
  {
    ref: 'nissan-evalia',
    name: 'Nissan Evalia',
    kind: 'minivan',
    seats: 7,
    transmission: 'manual',
    fuel: 'petrol',
    photo: '/images/fleet/nissan-evalia.png',
  },
  {
    ref: 'toyota-aygo-x',
    name: 'Aygo X',
    kind: 'car',
    seats: 5,
    transmission: 'automatic',
    fuel: 'petrol',
    photo: '/images/fleet/toyota-aygo-x-left.png',
  },
  {
    ref: 'smart-fortwo-new',
    name: 'Smart New',
    kind: 'car',
    seats: 2,
    transmission: 'automatic',
    fuel: 'petrol',
    photo: '/images/fleet/smart-forfour.png',
  },
  {
    ref: 'smart-forfour-automatic',
    name: 'Smart forfour',
    kind: 'car',
    seats: 5,
    transmission: 'automatic',
    fuel: 'petrol',
    photo: '/images/fleet/smart-forfour.png',
  },
  {
    ref: 'fiat-500-new-automatic',
    name: 'Fiat 500 New',
    kind: 'car',
    seats: 4,
    transmission: 'automatic',
    fuel: 'petrol',
    photo: '/images/fleet/fiat-500.png',
  },
  {
    ref: 'hyundai-i10',
    name: 'Hyundai I10',
    kind: 'car',
    seats: 5,
    transmission: 'automatic',
    fuel: 'petrol',
    photo: '/images/fleet/hyundai-i10.png',
  },
  {
    ref: 'fiat-punto-evo',
    name: 'Fiat Punto Evo',
    kind: 'car',
    seats: 5,
    transmission: 'automatic',
    fuel: 'petrol',
    photo: '/images/fleet/fiat-punto-evo.png',
  },
  {
    ref: 'toyota-yaris-hybrid',
    name: 'Toyota Yaris Hybrid',
    kind: 'car',
    seats: 4,
    transmission: 'automatic',
    fuel: 'petrol',
    photo: '/images/fleet/toyota-yaris-hybrid.png',
  },
  {
    ref: 'fiat-600-new',
    name: 'Fiat 600 New',
    kind: 'car',
    seats: 5,
    transmission: 'automatic',
    fuel: 'petrol',
    photo: '/images/fleet/fiat-600-new.png',
  },
  {
    ref: 'ebike',
    name: 'E-Bike',
    kind: 'ebike',
    seats: 1,
    transmission: null,
    fuel: null,
    photo: '/images/fleet/ebike-right.png',
  },
  {
    ref: 'scooter-50',
    name: 'Scooter 50cc',
    kind: 'scooter',
    seats: 2,
    transmission: null,
    fuel: null,
    photo: '/images/fleet/scooter-50.png',
  },
  {
    ref: 'scooter-125',
    name: 'Scooter 125cc',
    kind: 'scooter',
    seats: 2,
    transmission: null,
    fuel: null,
    photo: '/images/fleet/scooter-125.png',
  },
  {
    ref: 'scooter-150',
    name: 'Scooter 150cc',
    kind: 'scooter',
    seats: 2,
    transmission: null,
    fuel: null,
    photo: '/images/fleet/scooter-150.png',
  },
  {
    ref: 'scooter-200',
    name: 'Scooter 200cc',
    kind: 'scooter',
    seats: 2,
    transmission: null,
    fuel: null,
    photo: '/images/fleet/scooter-200.png',
  },
  {
    ref: 'scooter-300',
    name: 'Scooter 300cc',
    kind: 'scooter',
    seats: 2,
    transmission: null,
    fuel: null,
    photo: '/images/fleet/scooter-300.png',
  },
  {
    ref: 'vespa',
    name: 'Vespa',
    kind: 'scooter',
    seats: 2,
    transmission: null,
    fuel: null,
    photo: '/images/photo/vespa-tour-poster.png',
  },
]
